"use client";

import type useLifestyleFilters from "../../hooks/useLifestyleFilters";
import { CATEGORY_LABELS, PRIZE_CATEGORIES, type PrizeCategory } from "../../lifestyle-constants";
import { CATEGORY_ICONS } from "../lifestyleIcons";
import DrawerRow from "./DrawerRow";

interface CategoryLobbyProps {
  filters: ReturnType<typeof useLifestyleFilters>;
  onOpenCategory: (category: PrizeCategory) => void;
}

/** The drawer's top level: one drill-down row per prize category. */
export default function CategoryLobby({ filters, onOpenCategory }: CategoryLobbyProps) {
  return (
    <div className="flex flex-col flex-1 min-h-0 overflow-y-auto">
      {PRIZE_CATEGORIES.map(category => {
        const Icon = CATEGORY_ICONS[category];
        const count = filters.categoryFacets.get(category) ?? 0;
        const isActive = filters.filters.category === category;

        return (
          <DrawerRow
            key={category}
            label={CATEGORY_LABELS[category]}
            icon={Icon && <Icon className={`shrink-0 w-6 h-6 ${isActive ? "text-primary" : "text-gray-5"}`} />}
            isActive={isActive}
            isDisabled={count === 0 && !isActive}
            onClick={() => onOpenCategory(category)}
          />
        );
      })}
    </div>
  );
}
